export default {
    setToken(state, token) {
        state.token = token;
    },
    setProductosNeo(state, prods) {
        state.productosNeo = prods
    },
    setProductosNeoRestauranteTodos(state, prods) {
        state.productosNeoRestauranteTodos = prods
    },
    setProductosNeoOpciones(state, ops) {
        state.productosNeoOpciones = ops;
    },
    setDatosNeo(state, datos) {
        state.url = datos.url,
            state.centro = datos.centro,
            state.apikey = datos.apikey
    },
    resetDatosNeo(state) {
        state.url = '',
            state.centro = '',
            state.apikey = ''
    }
}